import { render } from "./BlogGrid.vue?vue&type=template&id=9b38b72c&scoped=true"
import script from "./BlogGrid.vue?vue&type=script&lang=js"
export * from "./BlogGrid.vue?vue&type=script&lang=js"

import "./BlogGrid.vue?vue&type=style&index=0&id=9b38b72c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-9b38b72c"

export default script